<template>
  <PageSection
    class="training-section-gallery"
    :theme="isDark"
  >
    <template #default>
      <div class="container">
        <div
          v-if="title || (galleryItems && galleryItems.length)"
          class="header"
        >
          <div class="column-left">
            <h2
              v-if="title"
              class="title"
              v-inview-animate:once="{name: 'fade-down', duration: 500, delay: 300}"
              v-html="title"
            ></h2>
          </div>
          <div class="column-right">
            <SliderArrows
              v-if="swiperInstance && showArrows"
              :swiper="swiperInstance"
              :class="{'theme-white': isDark}"
              v-inview-animate:once="{name: 'fade-down', duration: 500, delay: 400}"
            />
          </div>
        </div>
        <Swiper
          v-if="galleryItems && galleryItems.length"
          class="gallery-slider"
          :slides-per-view="'auto'"
          :watchOverflow="true"
          @swiper="onSwiperInit"
          @resize="updateArrowsVisibility"
          @slideChange="updateArrowsVisibility"
          v-inview-animate:once="{name: 'fade-down', duration: 500, delay: 500}"
        >
          <SwiperSlide
            v-for="(item, index) in galleryItems"
            :key="`gallery-item-${index}`"
          >
            <TrainingSectionGalleryItem
              :image="item.Image"
              :image-mobile="item.ImageMobile"
              :title="item.Title"
              :description="item.Description"
            />
          </SwiperSlide>
        </Swiper>
      </div>
    </template>
  </PageSection>
</template>

<script>
import PageSection from '@/components/PageSection.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/swiper.scss';
import SliderArrows from '@/components/SliderArrows.vue';
import TrainingSectionGalleryItem from './TrainingSectionGalleryItem.vue';

export default {
  name: 'TrainingSectionGallery',
  components: {
    PageSection,
    Swiper,
    SwiperSlide,
    SliderArrows,
    TrainingSectionGalleryItem,
  },
  data() {
    return {
      swiperInstance: null,
      showArrows: true,
    };
  },
  methods: {
    onSwiperInit(swiper) {
      this.swiperInstance = swiper;
      this.updateArrowsVisibility(swiper);
    },
    updateArrowsVisibility(swiper) {
      // Скрываем стрелки если все слайды влезают
      this.showArrows = !(swiper.isBeginning && swiper.isEnd);
    },
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    galleryItems: {
      type: Array,
      default: () => [],
    },
    theme: {
      type: String,
      default: 'light',
      validator: (value) => ['light', 'dark'].includes(value),
    },
  },
  computed: {
    isDark() {
      return this.theme === 'dark';
    },
  },
};
</script>

<style lang="scss" scoped>
.training-section-gallery {
  overflow: hidden;

  @include wRule(
    padding-top,
    (
      xl: 120,
      lg: 100,
      md: 80,
      sm: 80,
    )
  );

  @include wRule(
    padding-bottom,
    (
      xl: 120,
      lg: 100,
      md: 80,
      sm: 80,
    )
  );

  .title {
    display: block;
    width: 100%;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: -0.02em;

    @include wRule(
      font-size,
      (
        xl: 65,
        lg: 50,
        md: 45,
        sm: 65,
      )
    );

    &:not(:last-child) {
      @include wRule(
        margin-bottom,
        (
          xl: 60,
          lg: 50,
          md: 40,
          sm: 50,
        )
      );
    }
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @include screen("sm", max) {
      flex-wrap: wrap;
      align-items: flex-start;
    }

    &:not(:last-child) {
      @include wRule(
        margin-bottom,
        (
          xl: 60,
          lg: 50,
          md: 40,
          sm: 50,
        )
      );
    }
  }

  .column-left {
    flex: 1;

    @include wRule(
      margin-right,
      (
        xl: 60,
        lg: 40,
        md: 30,
        sm: 0,
      )
    );
    @include wRule(
      margin-bottom,
      (
        sm: 35,
      )
    );

    @include screen("sm", max) {
      width: 100%;
    }
  }

  .column-right {
    flex-shrink: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    @include screen("sm", max) {
      width: 100%;
    }
  }

  .gallery-slider {
    overflow: visible;

    @include wRule(
      padding-right,
      (
        sm: 130,
      )
    );

    ::v-deep(.swiper-wrapper) {
      @include wRule(
        gap,
        (
          xl: 40,
          lg: 30,
          md: 24,
          sm: 20,
        )
      );
    }
  }

  .swiper-slide {
    width: auto;

    @include wRule(
      width,
      (
        xl: 360,
        lg: 320,
        md: 280,
        sm: 260,
      )
    );
  }
}
</style>
